import React from 'react';
import { AlertTriangle } from 'lucide-react';

const AvailabilityWarningBanner = ({ hasIssues, isEditMode = false }) => {
  if (!hasIssues) return null;

  return (
    <div className="bg-amber-50 border border-amber-300 rounded-lg p-3 flex items-start">
      <AlertTriangle className="w-5 h-5 text-amber-500 mr-2 flex-shrink-0 mt-0.5" />
      <div>
        <p className="font-medium text-amber-800">Beschikbaarheid Waarschuwing</p>
        <p className="text-sm text-amber-700">
          {isEditMode 
            ? 'Sommige apparatuur of personeel is mogelijk niet beschikbaar voor de geselecteerde datums. Controleer de conflicten hierboven voordat u opslaat.'
            : 'Sommige apparatuur of personeel is mogelijk niet beschikbaar voor de geselecteerde datums. U kunt het project nog steeds aanmaken, maar controleer de conflicten hierboven.'}
        </p>
      </div>
    </div>
  );
};

export default AvailabilityWarningBanner;
